import { useNavigate } from "react-router-dom";

// Images
import homeJourneyPot from "../../../assets/img/HomePage/Mobile/home_journey_pot.png";
import homeJourneyChefHat from "../../../assets/img/HomePage/Mobile/home_journey_chef_hat.png";
import homeJourneyHotPot from "../../../assets/img/HomePage/Mobile/home_journey_hot_pot.png";

const HomeBeginJourney = () => {
  const navigate = useNavigate();

  return (
    <section className="px-[20px] py-[40px] text-text-1000 bg-[#F8F8F8]">
      <div className="bg-primaryDark-400 px-[30px] py-[40px] rounded-[8px] relative">
        {/* Text Box */}
        <div className="relative z-[20]">
          <h3 className="text-[36px] font-raleway leading-tight mb-[24px]">
            We connect passionate{" "}
            <span className="font-bold"> food entrepreneurs </span>
            with <span className="font-bold"> resource providers </span> who are
            ready to maximize their space.
          </h3>

          <h5 className="text-[20px] font-raleway leading-tight mb-[24px]">
            Begin your journey with HomeCook by letting us know if you’re a…
          </h5>

          {/* Buttons */}
          <div className="flex flex-col gap-[16px] w-full">
            <p>
              <button
                className="flex items-center justify-center gap-[8px] border-2 border-text-1000 px-[24px] py-[12px] text-[14px] text-text-1000 font-semibold font-raleway rounded-[8px] hover:bg-primaryDark-0/20 hover:text-text-1000 transition-all w-full"
                onClick={() => {
                  navigate("/food-entrepreneurs");
                }}
              >
                Food Entrepreneur
              </button>
            </p>

            <p>
              <button
                className="flex items-center justify-center gap-[8px] bg-text-1000 border-2  border-text-1000 px-[24px] py-[12px] text-[14px] text-primaryDark-0 font-semibold font-raleway rounded-[8px] hover:bg-primaryDark-0/20 hover:text-text-1000 transition-all w-full"
                onClick={() => {
                  navigate("/resource-providers");
                }}
              >
                Resource Provider
              </button>
            </p>
          </div>
        </div>

        {/* Icons */}
        <div>
          <img
            src={homeJourneyPot}
            alt="Home Journey Pot"
            className="absolute z-[10] top-[90px] left-0 w-[80px] h-[80px]"
          />
          <img
            src={homeJourneyChefHat}
            alt="Home Journey Chef Hat"
            className="absolute z-[10] bottom-0 right-[50%] translate-x-[50%] w-[72px] h-[72px]"
          />
          <img
            src={homeJourneyHotPot}
            alt="Home Journey Hot Pot"
            className="absolute z-[10] top-[190px] right-0 w-[80px] h-[80px]"
          />
        </div>
      </div>
    </section>
  );
};

export default HomeBeginJourney;
